var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export const formatIconName = (value) => {
    const splittedValue = value.split(/(?=[A-Z])/);
    const iconType = splittedValue[0];
    const iconName = splittedValue.slice(1).join('-').toLowerCase();
    return [iconType, iconName];
};
const Icon = (_a) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    return (_jsx(FontAwesomeIcon, Object.assign({}, props, { icon: formatIconName(name) })));
};
export default Icon;
//# sourceMappingURL=index.js.map